import { ErrorCode } from '../schemas/errors.js';
export const ERROR_CODE_HTTP_STATUS = {
    [ErrorCode.AUTH_REQUIRED]: 401,
    [ErrorCode.AUTH_INVALID]: 401,
    [ErrorCode.AUTH_EXPIRED]: 401,
    [ErrorCode.API_KEY_INVALID]: 401,
    [ErrorCode.API_KEY_LIMIT]: 403,
    [ErrorCode.QUOTA_EXCEEDED]: 402,
    [ErrorCode.PAYMENT_REQUIRED]: 402,
    [ErrorCode.CYCLE_EXPIRED]: 402,
    [ErrorCode.PLAN_QUALITY_NOT_ALLOWED]: 403,
    [ErrorCode.RATE_LIMITED]: 429,
    [ErrorCode.UPSTREAM_RATE_LIMITED]: 429,
    [ErrorCode.STRIPE_WEBHOOK_INVALID]: 400,
    [ErrorCode.SAME_PLAN]: 400,
    [ErrorCode.NO_ACTIVE_PLAN]: 400,
    [ErrorCode.GENERATION_FAILED]: 502,
    [ErrorCode.CONTENT_VIOLATION]: 422,
    [ErrorCode.CONTENT_POLICY_VIOLATION]: 422,
    [ErrorCode.MODEL_UNAVAILABLE]: 503,
    [ErrorCode.UPSTREAM_TIMEOUT]: 503,
    [ErrorCode.UPSTREAM_UNAVAILABLE]: 503,
    [ErrorCode.PIPELINE_STAGE1_FAILED]: 502,
    [ErrorCode.PIPELINE_STAGE2_FAILED]: 502,
    [ErrorCode.PIPELINE_ALL_FAILED]: 502,
    [ErrorCode.EDIT_SESSION_EXPIRED]: 403,
    [ErrorCode.EDIT_SESSION_NOT_FOUND]: 404,
    [ErrorCode.EDIT_SESSION_INVALID_STATE]: 409,
    [ErrorCode.EDIT_NONCE_INVALID]: 403,
    [ErrorCode.EDIT_HMAC_MISMATCH]: 403,
    [ErrorCode.DISPOSABLE_EMAIL_BLOCKED]: 403,
    [ErrorCode.SIGNUP_IP_LIMIT_REACHED]: 429,
    [ErrorCode.ABUSE_THROTTLED]: 429,
    [ErrorCode.ACCOUNT_PENDING_DELETION]: 403,
    [ErrorCode.ACCOUNT_RESTRICTED]: 403,
    [ErrorCode.GDPR_EXPORT_FAILED]: 500,
    [ErrorCode.GDPR_DELETION_FAILED]: 500,
    [ErrorCode.NOT_FOUND]: 404,
    [ErrorCode.VALIDATION_ERROR]: 400,
    [ErrorCode.PAYLOAD_TOO_LARGE]: 413,
    [ErrorCode.INTERNAL_ERROR]: 500,
    [ErrorCode.IDEMPOTENCY_CONFLICT]: 409,
    [ErrorCode.INVALID_IDEMPOTENCY_KEY]: 400,
    [ErrorCode.SERVICE_DEGRADED]: 503,
};
export const DEFAULT_ERROR_MESSAGES = {
    [ErrorCode.AUTH_REQUIRED]: 'Authentication is required to access this resource.',
    [ErrorCode.AUTH_INVALID]: 'The provided authentication credentials are invalid.',
    [ErrorCode.AUTH_EXPIRED]: 'Your authentication session has expired. Please re-authenticate.',
    [ErrorCode.API_KEY_INVALID]: 'The provided API key is invalid or has been revoked.',
    [ErrorCode.API_KEY_LIMIT]: 'Maximum number of API keys has been reached.',
    [ErrorCode.QUOTA_EXCEEDED]: "You've used all your tokens this month.",
    [ErrorCode.PAYMENT_REQUIRED]: 'A valid subscription is required to use this feature.',
    [ErrorCode.CYCLE_EXPIRED]: 'Your billing cycle has ended and we are syncing with Stripe. Please retry in a few seconds.',
    [ErrorCode.PLAN_QUALITY_NOT_ALLOWED]: 'High quality generation is available on Pro and Power. Upgrade your plan, or generate at medium quality.',
    [ErrorCode.RATE_LIMITED]: 'Too many requests. Please try again later.',
    [ErrorCode.UPSTREAM_RATE_LIMITED]: 'Generation service temporarily busy. Please retry in a few seconds.',
    [ErrorCode.STRIPE_WEBHOOK_INVALID]: 'Invalid Stripe webhook signature.',
    [ErrorCode.SAME_PLAN]: 'You are already on this plan.',
    [ErrorCode.NO_ACTIVE_PLAN]: 'No active subscription found. Please subscribe first.',
    [ErrorCode.GENERATION_FAILED]: 'Image generation failed. Please try again.',
    [ErrorCode.CONTENT_VIOLATION]: 'The request was rejected due to content policy violation.',
    [ErrorCode.CONTENT_POLICY_VIOLATION]: 'The request was blocked by the image model content policy. Try rephrasing the prompt.',
    [ErrorCode.MODEL_UNAVAILABLE]: 'The requested model is currently unavailable.',
    [ErrorCode.UPSTREAM_TIMEOUT]: 'The upstream image generation request timed out. Please retry shortly.',
    [ErrorCode.UPSTREAM_UNAVAILABLE]: 'The upstream image generation service is temporarily unavailable.',
    [ErrorCode.PIPELINE_STAGE1_FAILED]: 'The first image-generation stage failed.',
    [ErrorCode.PIPELINE_STAGE2_FAILED]: 'The second image-generation stage failed.',
    [ErrorCode.PIPELINE_ALL_FAILED]: 'All image-generation attempts failed.',
    [ErrorCode.EDIT_SESSION_EXPIRED]: 'This editor link has expired.',
    [ErrorCode.EDIT_SESSION_NOT_FOUND]: 'Editor session not found.',
    [ErrorCode.EDIT_SESSION_INVALID_STATE]: 'Editor session is not in a valid state for this operation.',
    [ErrorCode.EDIT_NONCE_INVALID]: 'This editor link has already been used.',
    [ErrorCode.EDIT_HMAC_MISMATCH]: 'Invalid editor session signature.',
    [ErrorCode.DISPOSABLE_EMAIL_BLOCKED]: 'Please use a permanent email address. Disposable email services are not supported.',
    [ErrorCode.SIGNUP_IP_LIMIT_REACHED]: 'Too many accounts created from this network. Please try again tomorrow.',
    [ErrorCode.ABUSE_THROTTLED]: 'Too many generation requests. Please slow down and try again shortly.',
    [ErrorCode.ACCOUNT_PENDING_DELETION]: 'Your account is scheduled for deletion. Generation and editing are disabled during the grace period.',
    [ErrorCode.ACCOUNT_RESTRICTED]: 'Your account is currently paused. Contact support to reactivate.',
    [ErrorCode.GDPR_EXPORT_FAILED]: 'Failed to compile your data export. Please try again.',
    [ErrorCode.GDPR_DELETION_FAILED]: 'Account deletion could not be initiated. Please try again or contact support.',
    [ErrorCode.NOT_FOUND]: 'The requested resource was not found.',
    [ErrorCode.VALIDATION_ERROR]: 'The request contains invalid data.',
    [ErrorCode.PAYLOAD_TOO_LARGE]: 'The uploaded file exceeds the maximum allowed size.',
    [ErrorCode.INTERNAL_ERROR]: 'An unexpected internal error occurred.',
    [ErrorCode.IDEMPOTENCY_CONFLICT]: 'A conflicting request with the same idempotency key is in progress.',
    [ErrorCode.INVALID_IDEMPOTENCY_KEY]: 'Billable endpoints require a valid Idempotency-Key header (UUID v4).',
    [ErrorCode.SERVICE_DEGRADED]: 'Billing infrastructure is temporarily unavailable. Please retry shortly.',
};
const ERROR_CODE_HTTP_STATUS_MAP = new Map(Object.entries(ERROR_CODE_HTTP_STATUS));
const DEFAULT_ERROR_MESSAGES_MAP = new Map(Object.entries(DEFAULT_ERROR_MESSAGES));
export function getErrorCodeHttpStatus(code) {
    return ERROR_CODE_HTTP_STATUS_MAP.get(code) ?? 500;
}
export function getDefaultErrorMessage(code) {
    return DEFAULT_ERROR_MESSAGES_MAP.get(code) ?? DEFAULT_ERROR_MESSAGES[ErrorCode.INTERNAL_ERROR];
}
//# sourceMappingURL=errors.js.map